(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["leave-a-tip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('tip-form');
    if (!form) return;

    var buttons = form.querySelectorAll('.tip-amount-btn');
    var customInput = document.getElementById('tip-custom-amount');
    var quantityField = document.getElementById('tip-quantity');
    var errorEl = document.getElementById('tip-error');

    function selectPreset(btn) {
      buttons.forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      customInput.value = '';
      quantityField.value = btn.getAttribute('data-amount');
      errorEl.hidden = true;
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectPreset(btn);
      });
    });

    customInput.addEventListener('input', function () {
      buttons.forEach(function (b) { b.classList.remove('is-selected'); });
      var val = parseInt(customInput.value, 10);
      quantityField.value = isNaN(val) ? '' : val;
      errorEl.hidden = true;
    });

    form.addEventListener('submit', function (e) {
      var qty = parseInt(quantityField.value, 10);
      if (!qty || qty < 1) {
        e.preventDefault();
        errorEl.hidden = false;
        errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var submitBtn = document.getElementById('tip-submit');
      submitBtn.textContent = 'Redirecting to checkout...';
      submitBtn.disabled = true;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
